import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Breadcrumb, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  addCategory,
  editCategory,
  updateCategory,
} from "../../../store/actions";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useRef } from "react";
import Loading from "../../../Common/extra/loading";

const AddCategoryIndex = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const compMounted = useRef();
  const [loading, setLoading] = useState(false);
  const userData = useSelector((s) => s?.Categories?.categories?.data);
  const id = location.pathname.split("/")[3];
  const [data, setData] = useState({
    userId: "",
    name: "",
  });

  const [errors, setError] = useState({
    name: "",
  });

  useEffect(() => {
    if (id && userData) {
      setData((pre) => ({ ...pre, name: userData?.name }));
    }
  }, [userData, id]);
  useEffect(() => {
    if (id) {
      dispatch(editCategory(id));
    }
    setData((pre) => ({
      ...pre,
      userId: id,
    }));
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const Error = { ...errors };

    switch (name) {
      case "name":
        Error[name] = "";
        if (value.length < 1) {
          Error[name] = "Required";
          Error["disabled"] = true;
        } else {
          Error["disabled"] = false;
          ("");
        }
        break;
      default:
        break;
    }
    setData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setError((pre) => ({ ...pre, ...Error }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const callBack = (response) => {
      if (response.data) {
        setLoading(false);
        toast.success("Category Added Successfully");
        setTimeout(() => {
          navigate("/temp-categories");
        }, 500);
      } else {
        setLoading(false);
        toast.error("");
      }
    };
    const updateCallback = (response) => {
      if (response.data) {
        setLoading(false);
        toast.success("Category Updated Successfully");
        setTimeout(() => {
          navigate("/temp-categories");
        }, 500);
      } else {
        setLoading(false);
        toast.error("");
      }
    };

    let body = {
      name: data.name,
      userId: data.userId,
      status: "1",
    };
    if (id) {
      dispatch(updateCategory(body, updateCallback));
    } else {
      dispatch(addCategory({ name: data.name }, callBack));
    }
  };
  return (
    <>
      {loading && <Loading className={"cstmLoader"} />}
      <section className="dashboard profile-main py-2">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="top mb-2">
                <Breadcrumb>
                  <Breadcrumb.Item href="/temp-categories">
                    Template Category
                  </Breadcrumb.Item>
                  <Breadcrumb.Item active>
                    {id ? "Edit" : "Add"}
                  </Breadcrumb.Item>
                </Breadcrumb>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div className="bg-white card-box px-4 py-3 rounded">
                <Form>
                  <Row>
                    <Col lg="6" className="my-2">
                      <label htmlFor="" className="form-label2 m-0">
                        Name
                      </label>
                      <input
                        type="text"
                        name="name"
                        value={data?.name}
                        onChange={handleChange}
                        placeholder=""
                        className="form-control"
                      />
                      <span className="note error_note py-2 m-0 text-danger">
                        {errors.name}
                      </span>
                    </Col>
                    <Col lg="12" className="my-2">
                      <div className="pt-4 btn-wrp d-flex algign-items-center">
                        <Button
                          disabled={data.name == "" ? true : false}
                          onClick={handleSubmit}
                          className="d-flex align-items-center justify-content-center me-2"
                        >
                          Submit
                        </Button>
                        <Link
                          to={`/temp-categories`}
                          className="d-flex btn-2 border align-items-center justify-content-center me-2"
                        >
                          <span className="me-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="12"
                              height="9"
                              viewBox="0 0 12 9"
                              fill="none"
                            >
                              <path
                                d="M2.8725 3.75L5.5575 1.0575L4.5 0L0 4.5L4.5 9L5.5575 7.9425L2.8725 5.25H12V3.75H2.8725Z"
                                fill="black"
                              />
                            </svg>
                          </span>
                          Back
                        </Link>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
export default AddCategoryIndex;
